import { Reveal } from "@/components/Reveal";

export default function SectionHeading({ number, overline, title, dark = false, center = false }) {
  return (
    <Reveal className={center ? "text-center" : ""}>
      <div className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}>
        {number && (
          <span className={`font-display text-sm italic ${dark ? "text-gold" : "text-gold-dark"}`}>
            {number}
          </span>
        )}
        <span className={`overline-label ${dark ? "!text-gold" : ""}`}>{overline}</span>
        <span className={`h-px w-12 ${dark ? "bg-gold/50" : "bg-gold-dark/50"}`} />
      </div>
      <h2
        className={`mt-5 font-display text-4xl leading-[1.1] tracking-tight sm:text-5xl ${
          dark ? "text-sand" : "text-navy"
        }`}
      >
        {title}
      </h2>
    </Reveal>
  );
}
